<template>
  <div class="cv-template-main">

    <div class="module-item template-module">
      <div class="cvs-title" v-if="temps.length"><span>推荐模板</span></div>
      <div class="recommend-template-box" v-if="temps.length">
        <div class="recommend-template-item">
          <div class="template-item-img-box" @click="previewCvFunc(temps[0])">
            <img class="template-item-img" :src="temps[0].cn_img || temps[0].en_img" alt="">
            <i class="iconfont iconzoom-out1"></i>
          </div>
          <div class="template-item-info">

            <div class="template-item-title">
              <h6>{{ temps[0].cn }}模板</h6>
              <div>推荐</div>
            </div>

            <p class="template-item-subtitle">{{ temps[0].temp_desc }}</p>

            <div class="template-item-hr-box">

              <div class="template-item-hr-header">
                <div>
                  <img class="template-item-hr-avatar" :src="temps[0].hr_avatar" alt="">
                  <span class="template-item-hr-name">{{ `${temps[0].hr_name} · ${temps[0].hr_position}` }}</span>
                </div>
                <!-- <img class="template-item-hr-icon" src="https://files.wondercv.com/PC/cvs/recommendedresume_pattern.png" alt=""> -->
              </div>

              <p class="template-item-hr-desc">“{{ temps[0].hr_desc }}”</p>

            </div>

            <div class="template-item-btn-box pr">
              <!-- 中英文模板 -->
              <template v-if="temps[0].cn_img && temps[0].en_img">
                <button class="template-item-btn cn" @click="useTemplateFunc('cn')">中文模板</button>
                <button class="template-item-btn en" @click="useTemplateFunc('en')"><span>英文模板</span></button>
              </template>
              <!-- 中文模板 -->
              <template v-else-if="temps[0].cn_img && !temps[0].en_img">
                <button class="template-item-btn cn" @click="useTemplateFunc('cn')">立即使用</button>
              </template>
              <!-- 英文模板 -->
              <template v-else-if="!temps[0].cn_img && temps[0].en_img">
                <button class="template-item-btn cn" @click="useTemplateFunc('en')">立即使用</button>
              </template>
              <a class="service-link pa" href="/service" target="_blank">
                <span class="iconfont iconbianji1"></span>
                <span class="text f_13">导师帮我写</span>
              </a>
            </div>

          </div>
        </div>
      </div>

      <!-- <div class="recommeed" v-if="temps.length">
        <div class="recommeed-menu" v-for="item in (temps.length > 2 ? 2 : temps.length)" :key="item">
          <div class="recommeed-title">
            <div class="">{{temps[item - 1]['cn'] + '模板'}}<i class="iconfont"></i></div>
            <div class="recommeed-btn">
              <button :class="option[item - 1] === 0 ? 'active' : ''" v-if="temps[item - 1]['cn_img']" @click.stop="setOption(item - 1, 0)">中文</button>
              <button :class="option[item - 1] === 1 ? 'active' : ''" v-if="temps[item - 1]['en_img']" @click.stop="setOption(item - 1, 1)">英文</button>
            </div>
          </div>
          <div class="recommeed-img">
            <img :src="temps[item - 1][option[item - 1] === 0 ? 'cn_img' : 'en_img']" alt="">
            <div class="recommeed-cover">
              <button class="recommeed-use" @click.stop="useTemplate(option[item - 1], temps[item - 1])">立即使用</button>
            </div>
          </div>
          <div class="recommeed-info">
            <span>推荐</span>{{temps[item - 1]['temp_desc']}}
          </div>
        </div>
      </div> -->

    </div>

    <div class="module-item">
      <div class="cvs-title">
        <span>优秀风格模版</span>
        <!-- <div class="title-right pointer" @click="moreTemplate">查看更多</div> -->
      </div>
      <div class="template" v-if="templates.length">
        <div class="menu-list">
          <template v-for="(item, index) in templates" >
            <div v-if="item.type === 'excellent'" class="menu" :key="index" @click="toTemplateDetail(item)">

              <!-- <img :src="images[item.en]" alt="">
              <p class="title">{{item.cn}}</p>
              <p class="desc">{{item.temp_desc}}</p> -->

              <!-- <div class="btn">
                <button v-if="item.cn_img" @click="selectTemplate(item.cn_token, item.cn_img, 'cn')">中文模板</button>
                <button v-if="item.en_img" @click="selectTemplate(item.en_token, item.en_img, 'en')">英文模板</button>
              </div> -->

              <img class="preview-image" :src="item.image" alt="">
              <div class="name">{{ item.name }}</div>
              <img class="vip-icon" src="https://logo.wondercv.com/banners/hK36TrJR7k7H79H.png" alt="" v-if="item.isMember">
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="module-item">
      <div class="cvs-title"><span>大牛简历</span><div class="title-right pointer" @click="moreTemplate"><span>查看更多</span></div></div>
      <div class="cow">
        <div class="cow-menu" v-for="item in (mubans.length > 10 ? 10 : mubans.length)" :key="item" @click="templateDetails(mubans[item - 1])">
          <div class="cow-picture">
            <img :src="mubans[item - 1].img" alt="">
            <!-- <img src="https://files.wondercv.com/PC/cvs/resume/bg.png" alt="" srcset="" class="company-logo-bj" v-if="mubans[item - 1].company_logo"> -->
            <!-- <img :src="mubans[item - 1].company_logo" alt="" srcset="" v-if="mubans[item - 1].company_logo" class="company-logo"> -->
          </div>
          <p class="text-overflow">{{mubans[item - 1].name}}</p>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { mapState } from 'vuex';
import { TEMPLATE_IMAGES } from '@/assets/js/const';
import { dealSignatrue, routerTo } from '@/assets/js/util';
import api from '@/api';
import { get_tUser } from '@/assets/js/util';
import template from '@/assets/json/template';

export default {
  props: {
    noCvSuggestedTemplateList: {
      type: Array,
      default: []
    },
    noCvSampleTemplateList: {
      type: Array,
      default: []
    },
    noCvExcellentTemplateList: {
      type: Array,
      default: []
    }
  },
  name: 'CvTemplate',
  data() {
    return {
      images: TEMPLATE_IMAGES,
      mubans: [],
      option: [0],
      temps: [],
      user: {},
      templates: [],

    }
  },
  async created() {
    this.templates = this.noCvExcellentTemplateList.length ? this.noCvExcellentTemplateList : template

    // this.$store.dispatch('cvs/getTemplates');
    // let res = await api.template.getTemplateIndex();
    // this.mubans = res.data.sample_cvs;

    this.user = await get_tUser();
    // let temp_res = await api.cvsV3.getCvsTemplate(this.user.c_t);
    // temp_res.data.names = ['aboard_ba']
    // this.templates.forEach(item => {
    //   if (item.en === temp_res.data.names[0]) {
    //     this.temps.push(item)
    //   }
    // })
    // this.temps = this.templates.filter(i => temp_res.data.names == (i.en))
    // console.log(111, template)
    template.forEach(item => {
      if (item.en === this.noCvSuggestedTemplateList[0]) {
        this.temps.push(item)
      }
    })
    this.mubans = this.noCvSampleTemplateList
  },
  methods: {
    toTemplateDetail(data) {
      window.location.href = `${window.location.origin}/jianlimoban/${data.id}.html`
    },
    // 预览简历
    previewCvFunc (data) {
      if (data.cn_img && data.en_img) {
        this.selectTemplate(data.cn_token, data.cn_img, 'cn')
      } else if (data.cn_img && !data.en_img) {
        this.selectTemplate(data.cn_token, data.cn_img, 'cn')
      } else if (!data.cn_img && data.en_img) {
        this.selectTemplate(data.en_token, data.en_img, 'en')
      }
    },
    setOption(index, value) {
      this.$set(this.option, index, value);
    },
    // 立即使用模板
    useTemplateFunc (type) {
      let token = this.temps[0][`${type}_token`]
      routerTo(`/cvs/${token}/editor`)
    },
    // 使用模板
    async useTemplate(index, data) {
      let token = ''
      if (index === 0){
        token = data.cn_token
      }else{
        token = data.en_token
      }
      routerTo(`/cvs/${token}/editor`);
    },
    // 选择模板
    selectTemplate(token, img, type) {
      this.$store.dispatch('app/setAlertData', {
        show: true,
        type: 'job',
        jobImage: img,
        jobToken: token,
        jobType: type,
      })
    },
    moreTemplate() {
      routerTo('/jianlimoban/', '_blank');
    },
    templateDetails(data) {
      routerTo(`/jianlimoban/${data.token}.html`, '_blank');
    }
  },
}
</script>
<style lang="scss" scoped>
  @import "./cvsTemplate.scss";
</style>